/*eslint-disable*/
import Flickity from 'flickity'
export default subcategoryModule => {
  let pressCards = $(subcategoryModule).find('.js-clp-cards').get(0)
  const setSliderParams = flkty => {
    flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })

    setTimeout(() => {
      $('body').find('.flickity-viewport').each((idx, flkty) => {
        flkty.querySelector('.flickity-slider').childNodes.length > 1 && $(flkty).closest('.flickity-enabled').find('.flickity-page-dots').css('opacity', 1)
      })
      flkty.resize()
    }, 1500)
  }
  if (pressCards) {
    const pressCardsFlkty = new Flickity(pressCards, {
      contain: true,
      pagedots: true,
      prevNextButtons: false,
      wrapAround: true
    })
    setSliderParams(pressCardsFlkty)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/klp-super-shoppable-subcategory-main.js